import { ProfileCorporateSupervisorInfoModel } from 'api/backofficeApiClient';
import React from 'react';

import { Divider, Row, Col } from 'antd';
import { getFullName } from 'utils/personUtils';

type Props = {
  supervisor: ProfileCorporateSupervisorInfoModel;
};

export default function SupervisorCard(props: Props) {
  const { supervisor } = props;

  const supervisorName = getFullName(
    supervisor?.firstName,
    supervisor?.lastName,
  );

  return (
    <div className="divider-box">
      <div className="content-wrapper">
        <Row gutter={[4, 4]} className="titled-sheet">
          {!!supervisorName && (
            <Col xs={24} md={12}>
              <div className="title">Supervisor:</div>
              <div>{supervisorName}</div>
            </Col>
          )}

          {!!supervisor?.title && (
            <Col xs={24} md={12}>
              <div className="title">Title:</div>
              <div>{supervisor?.title}</div>
            </Col>
          )}

          {!!supervisor?.email && (
            <Col xs={24} md={12}>
              <div className="title">Email:</div>
              <div>{supervisor?.email}</div>
            </Col>
          )}

          {!!supervisor?.phoneNumber && (
            <Col xs={24} md={12}>
              <div className="title">Phone number:</div>
              <div>{supervisor?.phoneNumber}</div>
            </Col>
          )}
        </Row>
      </div>
      <Divider className="card-divider no-margin" />
    </div>
  );
}
